/** Promotion Router **/
(function () {

	SUGApp.config(['$routeProvider', '$compileProvider', function ($routeProvider, $compileProvider) {
		$compileProvider.aHrefSanitizationWhitelist(/^\s*(http|https|mailto|data):/);
		$routeProvider
			.when('/', {
				templateUrl: '/view/main/dspFallPromo2019.html',
				controller: 'promotionController'
			})

			.otherwise({
				redirectTo: '/'
			});
	}]);

}());

/** Promotion Controller **/
(function () {
	SUGApp.controller('promotionController', promotionController);

	promotionController.$inject = ['$scope', 'SUGUtilities', '$filter', '$q', '$timeout', '$window', 'errorService', 'promotionService', '$location', 'commonRegExService'];
	function promotionController($scope, util, $filter, $q, $timeout, $window, errorService, promotionService, $location, commonRegExService) {

		// form object
		$scope.form = {
			disabled: 	false,
			showTerms: 		false,
		};

		// view toggles
		$scope.processing = false;
		$scope.showView = 	'init';
		$scope.isLoggedIn = false;
		$scope.plinkoAnimation = '';
		$scope.isActivePromo = false;

		/************************
		 FUNCTIONS
		************************/

		/**
		 * Kicks off page flow tasks
		 * @constructor
		 */
		var init = function () {
			/* Init error service */
			$scope.es = errorService;
			$scope.es.init();

			// main data objects
			$scope.user = { emailAddress: '', memberID: 0, optIn: true };
			$scope.coupon = { code: '', id: 0 };

			// determine if the user is logged in
			$scope.isLoggedIn = isUserLoggedIn();
			promotionService.getActivePromo({}).then(function( result ) {
				var response = (util.lowerCaseKeys(result));
				$scope.isActivePromo = response.data.success && response.data.data.promoname === 'Reveal Your Deal 2019';
				determinePlayStatus();
			});

		};

		/**
		 * Disables / Enables processing UI
		 * @param {boolean} blnStatus - Required; Boolean indicating if page is or is not processing
		 */
		var isProcessing = function(blnStatus){
			// Fire processing event
			util.broadCast('isProcessing', blnStatus);
			//enable/disable the form
			$scope.form.disabled = blnStatus;
            if(blnStatus){
                util.showLoading('processing');
            }
		};

		/**
		 * Determine if the user is logged in currently
		 */
		var isUserLoggedIn = function(){
			var isLoggedIn = false;

			if ($window.userdef.memberid > 0) {
				$scope.user.emailAddress = $window.userdef.email;
				$scope.user.memberID = $window.userdef.memberid;
				isLoggedIn = true;
			}
			return isLoggedIn;
		};

        /**
         * Validation function for the Enter Your Email form
         * @param {String} emailAddress - an email address to validate
         */
		var validateEmail = function(emailAddress) {
			if( !commonRegExService.emailRegEx().test(emailAddress) ){
                $scope.es.setError('invalidEmail', 'no msg.');
            }
		};

        /**
         * Determine's the correct view for playing based on the user's email address.
         */
        var determinePlayStatus = function(){
			if( !$scope.isActivePromo ){
				$scope.setView('promoNotActive');
            }else if( $scope.user.emailAddress && $scope.user.emailAddress.length > 0 ){
				$scope.setView('playnow');
            }else{
                $scope.setView('email');
            }
        };

		/**
		 * Gets 1 of 8 plinko animations, randomly.
		 */
		var getPlinkoAnimation = function(){
			var plinkoIteration = Math.floor(Math.random() * 8) + 1;
			return '/images/reveal-your-deal-2019/Plinko-'+plinkoIteration+'-Once.gif';
		};

		/**
		 * Makes Service call to determine the coupon
		 */
		$scope.getUserInfoForPromo = function(){
			//begin processing
			isProcessing(true);

			var requestParams = {email:$scope.user.emailAddress};
			promotionService.getUserInfoForPromo(requestParams).then(function( result ) {
				var response = (util.lowerCaseKeys(result));
				if (util.ajaxResultInvalid(response)) {
					// error confirming
					$scope.setView('problems');
					//end processing
					isProcessing(false);
				} else {
					//set the coupon and user, then change the view
					$scope.coupon = response.data.data.coupon;
					$scope.user.emailAddress = response.data.data.user.emailaddress;
					$scope.user.memberID = response.data.data.user.memberid;
					$scope.plinkoAnimation = getPlinkoAnimation();
					$scope.setView('play');

					//end processing
					isProcessing(false);
				}
			});

		};

		/**
		 * Validate the email provided on submit (instead of onChange) before we load the user details
		 */
		$scope.checkEmailAddress = function(){
			isProcessing(true);

			// clear errors first
			$scope.es.clearErrors();

			// Validate the email before making the XHR
			validateEmail($scope.user.emailAddress);

			// If no errors then proceed
			if( !$scope.es.hasErrors ){
				$scope.setView('playnow');
			} else {
				isProcessing(false);
			}
		};

		/**
		 * Show / Hide the terms block
		 */
		$scope.toggleTerms = function(){
			$scope.form.showTerms = !$scope.form.showTerms;

			// Scroll to the Terms element or back up
			if( $scope.form.showTerms ){
				document.querySelector('.oct-promo--terms').scrollIntoView({ behavior: 'smooth' });
			} else {
				document.querySelector('.logo').scrollIntoView({ block: "start", inline: "nearest", behavior: 'smooth' });
			}
		};

		/**
		 * Process the newsletter opt-in and direct the user to the pricing page with the coupon code applied
		 */
		$scope.redeemCoupon = function(){
			isProcessing(true);

			var goToPricingAndApplyCoupon = function(){
				// redirect to the pricing page and auto apply the coupon
				if( $scope.coupon.id && $scope.coupon.id > 0 ){
					window.location.href = '/index.cfm?go=o.ProGeniusProducts&couponEntry=' + $scope.coupon.code;
				}
			};

			if( $scope.user.optIn ){
				var params = {
					memberid: $scope.user.memberID,
					emailaddress: $scope.user.emailAddress,
					optin: $scope.user.optIn
				};
				promotionService.processNewsletterOptIn(params).then(function( result ) {
					var response = (util.lowerCaseKeys(result));
					//end processing
					isProcessing(false);
					if (util.ajaxResultInvalid(response)) {
						$scope.es.setError('optin','no msg.');
						// auto uncheck the optin
						$scope.user.optIn = false;
					} else {
						goToPricingAndApplyCoupon();
					}
				}, function(error){
					$scope.es.setError('optin','no msg.');
					// auto uncheck the optin
					$scope.user.optIn = false;
					isProcessing(false);
				});
			}else{
				goToPricingAndApplyCoupon();
			}
		};

		/**
		 * Toggles the slide's views
		 * @param {String} view - Required; String indicating what view to display
		 */
		$scope.setView = function (view) {
			isProcessing(true);
			//change the view
			$scope.showView = view;
			isProcessing(false);
		};

		/**
		 * Determines whether the promo is over.
		 */
		$scope.isPromoOver = function(){
			var today = new Date();
			today.setHours(0,0,0,0); // clear the time

			var endDate = new Date('11/15/2019');
			return today > endDate;
		};

		// this gets called everytime the page loads
		init();
	}

}());
